import React, { useState, useEffect, createContext } from 'react';
import { ServerURL } from '../../../serverURL';
import { useAuthCheck } from '../../../context/authkeyCheck';

const WebSocketContext = createContext();

export const CandidateWebSocketProvider = ({ children }) => {  
    const {isAuthenticated} = useAuthCheck(); 
    const [chatSocket, setChatSocket] = useState(null);

    useEffect(() => {
        let socket;
        let reconnectTimeout;

        // Function to initialize WebSocket connection
        const connectWebSocket = () => {
            const wsUrl = `wss://${ServerURL.WEBSOCKET_HOST_URL}/ws/chat/${localStorage.getItem('candidateChatUserID')}/`;
            socket = new WebSocket(wsUrl);
            setChatSocket(socket);

            // WebSocket event listeners
            socket.onopen = () => {
                console.log('WebSocket connection established');
            };

            socket.onclose = () => {
                console.log('WebSocket connection closed, attempting to reconnect in 1 second');
                // Attempt to reconnect after 1 second
                reconnectTimeout = setTimeout(() => {
                    connectWebSocket();
                }, 1000);
            };

            socket.onerror = (error) => {
                console.error('WebSocket error:', error);
            };
        };

        // Initial WebSocket connection
        if(isAuthenticated){
            connectWebSocket();
        }        

        // Cleanup function
        return () => {
            if (socket) socket.close();
            clearTimeout(reconnectTimeout);
        };
    }, [isAuthenticated]);

    return (
        <WebSocketContext.Provider value={{ chatSocket }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    return React.useContext(WebSocketContext);
};
